import {
  MY_RFI_API_ORDER_BY_FIELD,
  mapMyRfiItemToGridRow,
  mapGridRowToExportRecord,
  sortConfigToApiSortParamsWithFieldMap,
  sortMyRfiItems,
  filterMyRfiItemsByClientFilters,
} from "../../../utils/myRfiGridRowMapper";
import { getGridArchiveCommentDisplay } from "../../../utils/gridArchiveCommentDisplay";
import { getAdminRfisAllPagesForExport } from "../../../api/api-methods";
import { buildRiskAwareExportData } from "../../../utils/gridExportAllRecords";

/**
 * Toggle server-side sort for Admin get_rfis vs client-side sort on the current page.
 */
export const BACKEND_RFIS_USE_SERVER_SORT = true;

/**
 * Admin get_rfis: `order_by` field names (must match backend contract).
 * Includes sponsor; other keys align with user RFI grid where applicable.
 */
export const BACKEND_RFI_API_ORDER_BY_FIELD = {
  sponsor: "sponsor_name",
  ...MY_RFI_API_ORDER_BY_FIELD,
};

export function sortBackendRfiConfigToApiSortParams(sortConfig) {
  return sortConfigToApiSortParamsWithFieldMap(
    BACKEND_RFI_API_ORDER_BY_FIELD,
    sortConfig
  );
}

export function sortBackendRfiItems(items, sortConfig) {
  return sortMyRfiItems(items, sortConfig);
}

export { filterMyRfiItemsByClientFilters };

export const BACKEND_RFI_EXPORT_HEADERS = [
  "Sponsor",
  "Vendor",
  "Type",
  "GxP",
  "Template",
  "Location",
  "Risk Summary",
  "Status",
  "Request Date",
  "Due Date",
  "Release Date",
  "Completion Date",
  "Cycle Time",
  "Archive Comment",
];

/**
 * @param {object} item — raw API row
 * @param {object} [riskSummary] — 14029 published summary for this row, when present
 */
export function mapBackendRfiItemToExportRecord(item, riskSummary = null) {
  const row = mapMyRfiItemToGridRow(item);
  const base = mapGridRowToExportRecord(row, riskSummary);
  return {
    Sponsor: item?.sponsorName ?? "",
    ...base,
    "Archive Comment": getGridArchiveCommentDisplay(item) || "",
  };
}

/**
 * Export-menu data builder for the admin "VQQ Requests" grid: fetches every
 * page of the current filter/sort selection and resolves Risk Summary cells
 * for the full export set. The page passes its live filter state in via
 * useGridExportRegistration.
 */
export const buildBackendRfisExportData = ({
  searchQuery,
  selectedIds,
  serverSortParams,
  sortConfig,
  dueDateFilter,
}) =>
  buildRiskAwareExportData({
    fetchAllPages: () =>
      getAdminRfisAllPagesForExport({
        searchQuery,
        provider: selectedIds.provider,
        templates: selectedIds.templates,
        status: selectedIds.status,
        services: selectedIds.services,
        sponsorIdList: selectedIds.sponsor,
        sortOptions: serverSortParams || {},
        dueDateFilter,
      }),
    refineItems: (items) => {
      const afterLocal = filterMyRfiItemsByClientFilters(items, selectedIds);
      return BACKEND_RFIS_USE_SERVER_SORT
        ? afterLocal
        : sortBackendRfiItems(afterLocal, sortConfig);
    },
    mapRecordWithSummary: mapBackendRfiItemToExportRecord,
    headers: BACKEND_RFI_EXPORT_HEADERS,
  });
